import React from "react";
import styled, { keyframes } from "styled-components";
import {
  Coins,
  TrendingUp,
  ShieldCheck,
  Library,
  BarChart,
  Sparkles,
  ArrowRight,
  Mail,
} from "lucide-react";

import { Briefcase, Megaphone, Users, GraduationCap } from "lucide-react";


/**
 * PartnerProgram
 * Standalone section for Program partnerski AnalizyiRaporty.pl
 *
 * Props (optional):
 * - contactEmail: default "kontakt@analizyiraporty.pl"
 * - programUrl:   default "https://analizyiraporty.pl/partner"
 */
const PartnerProgram = ({
  contactEmail = "biuro@analizyiraporty.pl",
  programUrl = "https://analizyiraporty.pl/partner",
}) => {
  return (
    <Section>
      <Wrap>
        <Header>
          <Title>Program partnerski AnalizyiRaporty.pl</Title>
          <Lead>
            <strong>Zarabiaj, polecając naszą aplikację.</strong> AnalizyiRaporty.pl to innowacyjna
            aplikacja, która przekształca złożone dane księgowe w czytelne raporty i analizy,
            dostarczając przedsiębiorcom kluczowych informacji do podejmowania strategicznych decyzji.
            Nasz program partnerski to doskonała okazja, by dołączyć do grona ekspertów i czerpać
            korzyści z polecania sprawdzonego rozwiązania.
          </Lead>
        </Header>

        <Grid>
          <Card>
            <Icon><Coins size={22} /></Icon>
            <CardTitle>Powtarzalny przychód</CardTitle>
            <CardText>Zarabiaj pasywnie na polecanych klientach.</CardText>
          </Card>
          <Card>
            <Icon><TrendingUp size={22} /></Icon>
            <CardTitle>Rosnąca prowizja</CardTitle>
            <CardText>Uzyskaj do 25% prowizji przy każdorazowej wpłacie klienta.</CardText>
          </Card>
          <Card>
            <Icon><ShieldCheck size={22} /></Icon>
            <CardTitle>Lojalność klientów</CardTitle>
            <CardText>Oferuj wartość dodaną i buduj trwałe relacje.</CardText>
          </Card>
          <Card>
            <Icon><Library size={22} /></Icon>
            <CardTitle>Gotowe materiały</CardTitle>
            <CardText>Korzystaj z naszych materiałów marketingowych.</CardText>
          </Card>
          <Card>
            <Icon><BarChart size={22} /></Icon>
            <CardTitle>Transparentność</CardTitle>
            <CardText>Pełny dostęp do statystyk i rozliczeń.</CardText>
          </Card>
          <Card>
            <Icon><Sparkles size={22} /></Icon>
            <CardTitle>Nowoczesny wizerunek</CardTitle>
            <CardText>Kojarz się z innowacyjnym rozwiązaniem.</CardText>
          </Card>
        </Grid>

        {/* === Dla kogo jest program partnerski (inserted before Steps) === */}
<AudienceSection>
  <AudienceTitle>Dla kogo jest program partnerski analizyiraporty.pl?</AudienceTitle>
<AudienceList>
  <li>
    <AudienceIcon><Briefcase size={18} /></AudienceIcon>
    <AudienceText>
      <strong>Biura rachunkowe i doradcy podatkowi</strong>
      <span>
        Dla biur, które chcą rozszerzyć swoją ofertę o nowoczesne narzędzie do analizy danych finansowych klientów.
        Zyskujesz dodatkowe źródło przychodu i realną wartość dla swoich klientów.
      </span>
    </AudienceText>
  </li>

  <li>
    <AudienceIcon><Megaphone size={18} /></AudienceIcon>
    <AudienceText>
      <strong>Influencerzy i twórcy finansowi</strong>
      <span>
        Dla osób budujących społeczność wokół finansów, przedsiębiorczości lub rozwoju osobistego.
        Możesz polecać rozwiązanie, które pomaga firmom lepiej zarządzać pieniędzmi – i zarabiać na każdej aktywnej subskrypcji.
      </span>
    </AudienceText>
  </li>

  <li>
    <AudienceIcon><Users size={18} /></AudienceIcon>
    <AudienceText>
      <strong>Zespoły sprzedażowe i konsultanci B2B</strong>
      <span>
        Dla handlowców, doradców i partnerów biznesowych mających kontakt z przedsiębiorcami.
        Oferujesz im praktyczne narzędzie do analizy działalności, a sobie – stały dochód pasywny.
      </span>
    </AudienceText>
  </li>

  <li>
    <AudienceIcon><GraduationCap size={18} /></AudienceIcon>
    <AudienceText>
      <strong>Firmy szkoleniowe, marketingowe i trenerzy biznesu</strong>
      <span>
        Dla organizacji i trenerów, którzy edukują przedsiębiorców w zakresie zarządzania, finansów czy rozwoju.
        Możesz włączyć analizyiraporty.pl jako element swoich programów i warsztatów.
      </span>
    </AudienceText>
  </li>
</AudienceList>

</AudienceSection>


        <Steps>
          <StepsTitle>Jak zacząć współpracę?</StepsTitle>
          <StepsList>
            <li>
              <StepBullet>1</StepBullet>
              <StepText>
                <strong>Podpisz umowę partnerską:</strong> Skontaktuj się z nami, aby omówić szczegóły i podpisać umowę.
              </StepText>
            </li>
            <li>
              <StepBullet>2</StepBullet>
              <StepText>
                <strong>Otrzymaj link i KOD afiliacyjny:</strong> Wykorzystaj unikalny link i podaj innym swój KOD do polecania aplikacji.
              </StepText>
            </li>
            <li>
              <StepBullet>3</StepBullet>
              <StepText>
                <strong>Promuj AnalizyiRaporty.pl:</strong> Wykorzystaj dostępne materiały marketingowe i swoją sieć kontaktów.
              </StepText>
            </li>
            <li>
              <StepBullet>4</StepBullet>
              <StepText>
                <strong>Otrzymuj prowizję:</strong> Regularnie otrzymuj prowizję za poleconych klientów.
              </StepText>
            </li>
          </StepsList>

          <CTArow>
            <CTAprimary href={`mailto:${contactEmail}`}>
              <Mail size={18} /> Napisz do nas <ArrowRight size={18} />
            </CTAprimary>
          </CTArow>

          <NextSteps>
            <strong>Następne kroki.</strong> Skontaktuj się z nami już dziś, aby dowiedzieć się więcej o Programie
            Partnerskim AnalizyiRaporty.pl i rozpocząć współpracę. Zyskaj powtarzalny przychód i wspólnie rozwijajmy
            innowacyjne rozwiązania dla biznesu! Napisz na{" "}
            <a href={`mailto:${contactEmail}`}>{contactEmail}</a> lub wejdź na{" "}
            <a href={programUrl} target="_blank" rel="noopener noreferrer">
              {programUrl.replace(/^https?:\/\//, "")}
            </a>.
          </NextSteps>
        </Steps>
      </Wrap>
    </Section>
  );
};

export default PartnerProgram;

/* ============== styles ============== */

const ACCENT = "#3bc3cc";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const Section = styled.section`
  position: relative;
  padding: 3rem 1rem;
  background: url("/back.jpg") no-repeat center center fixed;
  background-size: cover;
`;

const Wrap = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  animation: ${fadeIn} 0.6s ease both;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 2rem;
`;



const Title = styled.h2`
  font-size: 2.2rem;
  color: #1f2937;
  margin: 0 0 0.6rem 0;
`;

const Lead = styled.p`
  color: #4b5563;
  font-size: 1.05rem;
  line-height: 1.7;
  max-width: 900px;
  margin: 0 auto;
`;

const Grid = styled.div`
  margin: 2rem auto 1rem auto;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 580px) {
    grid-template-columns: 1fr;
  }
`;

const AudienceIcon = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, #ffffff 0%, ${ACCENT} 100%);
  border: 1px solid rgba(59,195,204,0.35);
  color: #0f172a;
`;


const AudienceSection = styled.section`
  margin-top: 1.25rem;
  padding: 1.25rem 0;
`;

const AudienceTitle = styled.h4`
  margin: 0 0 0.75rem 0;
  color: #111827;
`;

const AudienceList = styled.ol`
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    display: grid;
    grid-template-columns: 36px 1fr;
    align-items: start;
    gap: 0.75rem;
    padding: 0.5rem 0;
    color: #374151;
  }
`;

const AudienceText = styled.div`
  display: grid;
  gap: 0.25rem;

  span { line-height: 1.6; color: #4b5563; }
`;


const Card = styled.div`
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 14px;
  padding: 1rem;
  box-shadow: 0 8px 24px rgba(2, 8, 23, 0.05);
`;

const Icon = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  margin-bottom: 0.5rem;
  color: ${ACCENT};
  background: linear-gradient(135deg, #ffffff 0%, ${ACCENT} 100%);
  box-shadow: 0 6px 18px rgba(59,195,204,0.25);
`;

const CardTitle = styled.h3`
  margin: 0 0 0.25rem 0;
  font-size: 1.05rem;
  color: #111827;
`;

const CardText = styled.p`
  margin: 0;
  color: #6b7280;
  font-size: 0.95rem;
`;

const Steps = styled.section`
  margin-top: 1.5rem;
  background: transparent;

  padding: 1.25rem;

`;

const StepsTitle = styled.h4`
  margin: 0 0 0.75rem 0;
  color: #111827;
`;

const StepsList = styled.ol`
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    display: grid;
    grid-template-columns: 36px 1fr;
    align-items: start;
    gap: 0.75rem;
    padding: 0.5rem 0;
    color: #374151;
  }
`;

const StepBullet = styled.div`
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #ffffff 0%, ${ACCENT} 100%);
  color: #0f172a;
  border: 1px solid rgba(59,195,204,0.35);
  border-radius: 999px;
  display: grid;
  place-items: center;
  font-weight: 700;
  font-size: 0.9rem;
`;

const StepText = styled.span`
  line-height: 1.6;
`;

const CTArow = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
  flex-wrap: wrap;
`;

const CTAprimary = styled.a`
  background: ${ACCENT};
  color: #ffffff;
  font-weight: 700;
  text-decoration: none;
  padding: 0.75rem 1rem;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 8px 20px rgba(59,195,204,0.25);

  &:hover { filter: brightness(0.95); }
`;

const NextSteps = styled.p`
  margin-top: 1rem;
  color: #4b5563;

  a {
    color: #0d6efd;
    text-decoration: underline;
  }
`;
